module.exports = __webpack_public_path__ + "static/media/icon_bank_30.983583ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_bank_30.jpg
// module id = 882
// module chunks = 1